import { render, staticRenderFns } from "./GifteelistView.vue?vue&type=template&id=273ea9fa"
import script from "./GifteelistView.vue?vue&type=script&lang=js"
export * from "./GifteelistView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports